<template>
  <div class="card">
    <transition mode="out-in" name="fade">
      <component
        v-bind:is="text"
        v-if="texts"
        key="page"
        class="text"
        @next="page += 1"
        @start-sound="
          $emit('start-sound');
          page += 1;
        "
      ></component>
    </transition>
    <v-btn
      small
      color="transparent"
      elevation="0"
      class="skip-btn"
      @click="page = texts.length - 1"
      >Skip</v-btn
    >
  </div>
</template>

<script>
import Text1 from "./texts/Text1";
import Text2 from "./texts/Text2";
import Text3 from "./texts/Text3";
import Text5 from "./texts/Text5";
import Text6 from "./texts/Text6";
import Text7 from "./texts/Text7";
import Text9 from "./texts/Text9";

export default {
  components: { Text1, Text2, Text3, Text5, Text6, Text7, Text9 },

  data() {
    return {
      page: 0,
      texts: [Text1, Text2, Text3, Text5, Text6, Text7, Text9],
      interval: null,
    };
  },

  computed: {
    text() {
      return this.texts[this.page];
    },
  },
  methods: {
    emit(action) {
      this.$emit(action);
    },
  },
};
</script>

<style scoped>
.skip-btn {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  position: fixed;
  bottom: 3%;
  right: 2%;
  font-family: "MabryMedium";
  color: #c5d2ed;
}
.card {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0b3530;
  display: flex;
  justify-content: center;
  align-items: center;
}

.text,
h1 {
  position: absolute;
  width: 85%;
  font-style: normal;
  font-weight: bold;
  font-size: 64px;
  line-height: 77px;
  text-align: center;
  color: #fbf6ef;
  font-family: "MabryBold";
}
.fade-leave-active {
  transition: opacity 0.5s ease-in;
}
.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-leave,
.fade-enter-to {
  opacity: 1;
}
.volume-btn {
  position: absolute;
  z-index: 9999;

  top: 20px;
  right: 20px;
}
.volume-btn img {
  width: 24px;
}
</style>